export default __webpack_public_path__ + "static/media/reino-unido.320bf846.png";